var map = {
	"./hero-bg.webp": 967,
	"./logo-foodhall.jpg": 652,
	"./logo-teazzi.png": 30,
	"./logo.jpeg": 599,
	"./main-logo.png": 782,
	"./projects/projects-enchanting_valley.webp": 60,
	"./projects/projects-lamala.webp": 743,
	"./projects/projects-simetri.webp": 820,
	"./projects/projects-teazzi.webp": 616,
	"./projects/projects-ziel.webp": 457,
	"./simple-logo.png": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;